import { z } from 'zod';
import { MAX_ACCOUNT_NOTE_INPUT_LENGTH } from '@mews-commander/constants';
import { MAX_INPUT_TEXT_LENGTH, Validation } from '@mews/framework';

export enum FieldNames {
    Name = 'name',
    ShortName = 'shortName',
    ExternalName = 'externalName',
    Description = 'description',
    Ordering = 'ordering',
    Image = 'image',
    ImageId = 'imageId',
    Key = 'key',
    ExternalIdentifier = 'externalIdentifier',
}

export const formSchema = z.object({
    [FieldNames.Name]: Validation.String.Required.max(MAX_INPUT_TEXT_LENGTH),
    [FieldNames.ShortName]: z.string().max(MAX_INPUT_TEXT_LENGTH).nullish(),
    [FieldNames.ExternalName]: z.string().max(MAX_INPUT_TEXT_LENGTH).nullish(), // check length
    [FieldNames.Description]: z.string().max(MAX_ACCOUNT_NOTE_INPUT_LENGTH).nullish(),
    [FieldNames.Ordering]: z.number(),
    [FieldNames.ImageId]: z.string().nullish(),
    [FieldNames.Image]: z.array(z.instanceof(File)).nullish(),
    [FieldNames.Key]: Validation.String.Required.max(MAX_INPUT_TEXT_LENGTH),
    [FieldNames.ExternalIdentifier]: z.string().max(MAX_INPUT_TEXT_LENGTH).nullish(),
});

export type FormValues = z.infer<typeof formSchema>;
export type EditFormValues = Omit<FormValues, FieldNames.Key>;

export const emptyDefaultValues: FormValues = {
    [FieldNames.Name]: '',
    [FieldNames.ShortName]: '',
    [FieldNames.ExternalName]: '',
    [FieldNames.Description]: '',
    [FieldNames.Ordering]: 0,
    [FieldNames.Key]: '',
    [FieldNames.ExternalIdentifier]: '',
};
